import angular from 'angular';

import Component from './CardFlow.component';
import Service from './CardFlow.service';

export default angular.module('petroCloud.cardFlow', [])
  .service('CardFlowService', Service)
  .component(Component.name, Component)
  .name;
